<template>
  <div class="action-buttons-report">
    <c-btn
      :disabled="disableProofreader"
      background="#fbba00"
      :loading="ajaxPR"
      @click="sendToProofreader">
      <svg class="icon">
        <use xlink:href="/img/icons/icons-sprite.svg#send" />
      </svg>
      Send to ProofReader
    </c-btn>
    <c-btn
      :disabled="disableQaExpert"
      background="#77379a"
      :loading="ajaxQA"
      @click="sendToQaExpert">
      <svg class="icon">
        <use xlink:href="/img/icons/icons-sprite.svg#send" />
      </svg>
      Send to QA expert
    </c-btn>
    <c-btn
      :disabled="disableCustomer"
      background="#04a645"
      :loading="ajaxCustomer"
      @click="sendToCustomer">
      <svg class="icon">
        <use xlink:href="/img/icons/icons-sprite.svg#send" />
      </svg>
      Send to Customer
    </c-btn>
    <c-btn
      :disabled="disableLsp"
      background="#1e89bf"
      :loading="ajaxLSP"
      @click="sendToLSP">
      <svg class="icon">
        <use xlink:href="/img/icons/icons-sprite.svg#send" />
      </svg>
      Send to LSP
    </c-btn>
  </div>
</template>

<script>
import Vue from 'vue';
import Api from '@/utils/api';

export default Vue.extend({
  props: {
    errorsDataToSend: {
      type: Object,
    },
  },
  data: () => ({
    ajaxPR: false,
    ajaxQA: false,
    ajaxCustomer: false,
    ajaxLSP: false,
  }),
  computed: {
    disableLsp: () => true,
    disableCustomer: () => true,
    disableProofreader: () => true,
    disableQaExpert: () => true,
  },
  components: {
    'c-btn': () => import('@/components/button/index.vue'),
  },
  methods: {
    sendToCustomer() {
      this.ajaxCustomer = true;
      Api.reports.sendReport.customer(this.$route.params.id).then(() => {
        this.$root.$emit('notification', {
          message: 'Notification was successfully sended to Customer',
          type: 'info',
          show: true,
        });
      }).catch(() => {
        this.$root.$emit('notification', {
          message: 'Error while sending notification',
          type: 'error',
          show: true,
        });
      }).finally(() => {
        this.ajaxCustomer = false;
      });
    },
    sendToLSP() {
      this.ajaxLSP = true;
      Api.reports.sendReport.lsp(this.$route.params.id).then(() => {
        this.$root.$emit('notification', {
          message: 'Notification was successfully sended to LSP',
          type: 'info',
          show: true,
        });
      }).catch(() => {
        this.$root.$emit('notification', {
          message: 'Error while sending notification',
          type: 'error',
          show: true,
        });
      }).finally(() => {
        this.ajaxLSP = false;
      });
    },
    sendToProofreader() {
      this.ajaxPR = true;
      Api.reports.sendReport.proofReader(this.$route.params.id).then(() => {
        this.$root.$emit('notification', {
          message: 'Notification was successfully sended to ProofReader',
          type: 'info',
          show: true,
        });
      }).catch(() => {
        this.$root.$emit('notification', {
          message: 'Error while sending notification',
          type: 'error',
          show: true,
        });
      }).finally(() => {
        this.ajaxPR = false;
      });
    },
    sendToQaExpert() {
      this.ajaxQA = true;
      Api.reports.sendReport.qaExpert(this.$route.params.id).then(() => {
        this.$root.$emit('notification', {
          message: 'Notification was successfully sended to QA expert',
          type: 'info',
          show: true,
        });
      }).catch(() => {
        this.$root.$emit('notification', {
          message: 'Error while sending notification',
          type: 'error',
          show: true,
        });
      }).finally(() => {
        this.ajaxQA = false;
      });
    },
  },
});
</script>

<style lang="scss">
  .action-buttons-report {
    display: flex;

    .icon {
      margin-right: 4px!important;
    }

    >*+* {
      margin-left: 4px;
    }
  }
</style>
